import { createSlice } from '@reduxjs/toolkit';

interface CatalogSlice {
  data: {
    catalog: [
      {
        id: string;
        createdAt?: string;
        updatedAt?: string;
        name?: string;
        description?: string;
        url?: string;
        price?: number;
        sale_price?: number;
        currency?: string;
        condition?: string;
        availability?: string;
        retailer_id_status?: string;
        brand?: string;
        image_url?: any;
        preview: string;
        fb_product_category: string;
        retailer_id: string;
      }
    ];
    channel: any;
    handles : any;
    isShowSync: boolean;
    createCatalog: []
  };
}

const initialState: CatalogSlice = {
  data: {
    catalog: [
      {
        id: '',
        createdAt: '',
        updatedAt: '',
        name: '',
        description: '',
        url: '',
        price: 0,
        sale_price: 0,
        currency: 'IDR',
        condition: 'new',
        availability: 'in stock',
        retailer_id_status: 'auto_generated',
        brand: '',
        image_url: '',
        preview: '',
        fb_product_category: '',
        retailer_id: '',
      },
    ],
    channel: {},
    handles: {},
    isShowSync: false,
    createCatalog: [

    ]


  },
};

export const catalogSlice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    selectCatalog: (state, { payload }) => {
      state.data = { ...payload, header: {} };
    },
    resetCatalog: (state) => {
      state.data.catalog = initialState.data.catalog;
    },
    setCatalog: (state, action) => {
      state.data = action.payload;
    },
    setChannelId: (state, action) => {
      state.data.channel = action.payload;;
    },
    setHandle: (state, action) => {
      state.data.handles = action.payload;
    },
    setShowSync: (state, action) => {
      state.data.isShowSync = action.payload;
    },
    setCreateCatalog: (state, action) => {
      state.data = action.payload;
    },
    resetProductCatalog: (state) => {
      state.data.createCatalog = initialState.data.createCatalog;
    }
  },
});

export const { setCatalog, resetCatalog, selectCatalog, setChannelId, setHandle, setShowSync, setCreateCatalog, resetProductCatalog } =
  catalogSlice.actions;

export default catalogSlice.reducer;
